import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Icon, DatePicker, Input } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Colors from "../../../../../themes/Colors";
import ReplicateCampaignHolder from "../../styles/replicateCampaignStyle";

const { RangePicker } = DatePicker;

const checkDateRules = (currentCampaign) => {
  if (!currentCampaign || !currentCampaign.contents_displays) return false;
  for (const element of currentCampaign.contents_displays) {
    const contentsDisplays = element.content_child_contents || [element];
    for (const contentDisplay of contentsDisplays) {
      const rules = contentDisplay.rules ? JSON.parse(contentDisplay.rules) : null;
      if (!rules) continue;
      if (rules.some((rule) => rule.conditions.some((cond) => cond.type === "date"))) {
        return true;
      }
    }
  }
  return false;
};

const ReplicateCampaignModal = ({
  visible,
  campaignId,
  name,
  to_date: initTo,
  end_date: initEnd,
  currentCampaign,
  replicateCampaign,
  replicateCampaignId,
  replicatingCampaign,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [nameCampaing, setNameCampaing] = useState("");
  const [toDate, setToDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [nameError, setNameError] = useState(false);
  const [hasDateRules, setHasDateRules] = useState(false);
  const prevReplicating = useRef(replicatingCampaign);

  useEffect(() => {
    if (visible) {
      setNameCampaing(`${name} - ${t("Replicated")}`);
      setToDate(moment(initTo).format("YYYY-MM-DD"));
      setEndDate(moment(initEnd).format("YYYY-MM-DD"));
      setNameError(false);
      setHasDateRules(checkDateRules(currentCampaign));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    if (prevReplicating.current && !replicatingCampaign && replicateCampaignId) {
      window.location.replace(`/campaign/${replicateCampaignId}`);
    }
    prevReplicating.current = replicatingCampaign;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replicatingCampaign]);

  const handleDateChange = (dateStrings) => {
    setToDate(moment(dateStrings[0]).format("YYYY-MM-DD"));
    setEndDate(moment(dateStrings[1]).format("YYYY-MM-DD"));
  };

  const handleOk = () => {
    if (nameCampaing && toDate && endDate) {
      replicateCampaign(campaignId, {
        name: nameCampaing,
        start_date: toDate,
        end_date: endDate,
        new_ssp: currentCampaign.new_ssp,
      });
    } else {
      setNameError(!nameCampaing);
    }
  };

  return (
    <Modal
      title={t("Replicate campaign")}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t("Cancel")}
        </Button>,
        <Button key="ok" type="primary" onClick={handleOk} loading={replicatingCampaign}>
          {t("OK")}
        </Button>,
      ]}
    >
      <ReplicateCampaignHolder>
        <div className="content-input">
          <span className="Input">{t("Name")}</span>
          <Input
            placeholder=""
            onChange={(e) => {
              setNameCampaing(e.target.value);
              setNameError(false);
            }}
            value={nameCampaing}
            className={nameError ? "error" : ""}
          />
          {nameError && <p className="error-message">{t("The name is required")}</p>}
        </div>
        <div>
          <span>{t("Exhibition date")}</span>
          <span className="">
            <RangePicker
              value={[moment(toDate), moment(endDate)]}
              dropdownAlign={{ offset: [0, 8] }}
              onChange={handleDateChange}
              format="DD/MM/YYYY"
            />
          </span>
        </div>
        <div className="content-input-info">
          <p>
            <Icon
              style={{ fontSize: "15px", marginRight: "5px", color: Colors.atention }}
              type="info-circle"
            />
            {t(
              "A campaign with a pending payment status will be created, keeping the contents and screens that are still available for sale."
            )}
          </p>
        </div>
        {hasDateRules && (
          <div className="content-input-info">
            <p>
              <Icon
                style={{ fontSize: "15px", marginRight: "5px", color: Colors.atention }}
                type="info-circle"
              />
              {t(
                "The original campaign has rules based on dates, these will be removed. Remember to configure them again."
              )}
            </p>
          </div>
        )}
      </ReplicateCampaignHolder>
    </Modal>
  );
};

export default ReplicateCampaignModal;
